export default (PaperObj) => {
    var paper = PaperObj.paper;
    var pages = Math.ceil(paper.word_count / 325);
    console.log("calc cost")
    paper.doc_cost = PaperObj.pricing[paper.editor_level][paper.time_limit] * pages;
    console.log(paper.doc_cost)
    var extras_price = 0;
    console.log("------>>>------>>>------>>> checking paper ------>>>------>>>------>>>");
    console.log(paper.doc_cost);
    console.log();
    console.log(paper);
    console.log("------>>>------>>>------>>> checking paper ------>>>------>>>------>>>");

    var extras_diff = paper.doc_cost;
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'ESL');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'ExtraEditing');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'extraComments');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'Critiques');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'Formatting');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'CitationCorrection');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'Plagiarism');
    extras_price += getExtraPrice(paper.extras, paper.word_count, pages, 'gradeMyPaper');
    paper.doc_cost += extras_price;

    extras_diff = (paper.doc_cost - extras_price)

    let tempuplevelprice;
    let tempuptimeprice;
console.log("paper new editor level during calc is "+paper.editor_level);
console.log("paper new time limit during calc is "+paper.time_limit);
    switch (paper.editor_level){
        case 'bronze':
            tempuplevelprice = 'silver'
            paper.upsold_price_level = PaperObj.pricing[tempuplevelprice][paper.time_limit] * pages
            break;
        case 'silver':
            tempuplevelprice = 'gold'
            paper.upsold_price_level = PaperObj.pricing[tempuplevelprice][paper.time_limit] * pages
            break;
        case 'gold':
            tempuplevelprice = 'pro'
            paper.upsold_price_level = PaperObj.pricing[tempuplevelprice][paper.time_limit] * pages
            break;
        case 'pro':
            tempuplevelprice = 'pro'
            paper.upsold_price_level = PaperObj.pricing[tempuplevelprice][paper.time_limit] * pages
            break;
        default:
            tempuplevelprice = 'pro'
            paper.upsold_price_level = PaperObj.pricing[tempuplevelprice][paper.time_limit] * pages
            break;
    }
    console.log("going to switch over time limit with "+paper.time_limit);
    switch (paper.time_limit){
        case '1.5':
            tempuptimeprice = '1.5';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
        case '3':
            tempuptimeprice = '1.5';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
        case '7':
            tempuptimeprice = '3';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
        case '12':
            tempuptimeprice = '7';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
        case '24':
            tempuptimeprice = '12';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
        case '72':
            tempuptimeprice = '24';
            paper.upsold_price_time_limit = PaperObj.pricing[paper.editor_level][tempuptimeprice] * pages
            break;
         default:
             paper.upsold_price_time_limit = 0;
             paper.upsold_price_level = 0;
            break;
    }
console.log("paper.upsold_price_time_limit is "+paper.upsold_price_time_limit);
console.log(PaperObj.pricing);
console.log(paper.editor_level);
console.log(tempuptimeprice);
console.log(pages);
paper.extras_price = extras_price;
paper.extras_diff = extras_diff;
  return {
    upsell_level_price: +parseFloat(extras_diff) + +(parseFloat(paper.upsold_price_time_limit) - parseFloat(paper.doc_cost)),
    upsell_time_price: +parseFloat(extras_diff) + +(parseFloat(paper.upsold_price_level) - parseFloat(paper.doc_cost)),
    doc_cost: paper.doc_cost,
    extras_price: extras_price,
    pages: pages
  }
}

export function getExtraPrice (extras, wordCount, pages, extra) {
  if(pages === 0) {
    pages = Math.ceil(wordCount / 325); // find better way to always pass value from step4
  }
  if(extras && extras.indexOf(extra) < 0) { // extra not found in array - no extra cost
    return 0;
  }
  var extraCost = 0;
  switch(extra) {
    case 'ESL':
    case 'ExtraEditing':
    case 'extraComments':
    case 'Critiques':
    case 'Formatting':
    case 'CitationCorrection':
      extraCost = 10;
      if(pages>10) {
        extraCost += (pages-10);
      }
      break;
    case 'Plagiarism':
      extraCost = 10;
      if(wordCount > 2500) {
        extraCost = 20;
      }
      break;
    case 'gradeMyPaper':
      extraCost = 10;
      break;
    default:
      extraCost = 10;
  }
  return extraCost;
}


// WEBPACK FOOTER //
// ./src/util/calculatePrice.js